// Web implementation for tracking visibility.
export function trackVisibility(ref: any, onVisibleForDuration: any, duration = 10000, thresholdTrigger = 0.75) {
    if (!ref?.current) return () => {};

    let timerId: ReturnType<typeof setTimeout> | null = null;
    let isCounting = false;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting && !isCounting) {
                isCounting = true;
                timerId = setTimeout(() => {
                    onVisibleForDuration();
                    observer.disconnect();
                }, duration);
            } else if (!entry.isIntersecting) {
                if (timerId) {
                    clearTimeout(timerId);
                }
                isCounting = false;
            }
        },
        { threshold: thresholdTrigger },
    );

    observer.observe(ref.current);

    return () => {
        if (timerId) {
            clearTimeout(timerId);
        }
        observer.disconnect();
    };
}
